require("bootstrap");
import "bootstrap/dist/css/bootstrap.min.css";
require("jquery-smooth-scroll");

jQuery(function($) {
  var $offset = $("#home").height();
  console.log($offset);

  $(window).resize(function() {
    var $offset = $("[data-scroll-header]").height();

    $("a[data-scroll]").smoothScroll({
      offset: -$offset
    });
  });
});

jQuery(document).ready(function() {
  console.log("ready");

  var $hash = window.location.hash;
  var $offset = jQuery("[data-scroll-header]").height();
  var $element = jQuery($hash);

  $("a[data-scroll]").smoothScroll({
    offset: -$offset
  });

  // console.log(element.offset().top + ' ' + offset);
  // jQuery('html,body').animate({scrollTop: element.offset().top - offset}, 1000);
});
